import clsx from 'clsx'

import { AppBreakpoint } from '@makyoapp/makyo-sdk/models/AppBuilder'
import { Tip, useTip } from '@makyoapp/makyo-ui'

import { BUILDER_DEVICES } from '@/shared/builder-constants'

export function DeviceTab({
  device,
  isActive,
  onClick,
}: {
  device: AppBreakpoint
  isActive: boolean
  onClick: () => void
}) {
  const { Icon, label } = BUILDER_DEVICES[device]
  const { x, y, strategy, refs, context, placement, isOpen, arrowRef, getReferenceProps, getFloatingProps } = useTip()

  return (
    <>
      <button
        ref={refs.setReference}
        onClick={onClick}
        className={clsx(
          'h-12 aspect-square flex items-center justify-center transition-colors',
          'bg-slate-800 hover:bg-slate-700',
          isActive && 'bg-slate-900',
          device === 'phone' && 'rounded-l',
          device === 'tv' && 'rounded-r'
        )}
        {...getReferenceProps()}
      >
        <Icon className={clsx('w-5 h-5', isActive ? 'text-white' : 'text-slate-400')} />
      </button>
      {isOpen && (
        <Tip
          x={x}
          y={y}
          placement={placement}
          strategy={strategy}
          ref={refs.setFloating}
          {...getFloatingProps()}
          context={context}
          arrowRef={arrowRef}
        >
          {label}
        </Tip>
      )}
    </>
  )
}
